export const baseURL = process.env.REACT_APP_BaseAPIUrl;
export const clientId = process.env.REACT_APP_ClientId;
export const tenant = process.env.REACT_APP_TenantId;
console.log('BaseAPIUrl=' + process.env.REACT_APP_BaseAPIUrl);